
import HeartCircle from "../../../assets/filled/HeartCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HeartCircleIcon({ className, dataTestid = "HeartCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HeartCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
